export default "__VITE_ASSET__ead276e7__"